import React from "react";
import { Item } from "./Item";

export const ItemList = ({ items }) => {
  return (
    <>
      {items.map((item) => (
        <div key={item.id} className=" col-6 col-md-2 item ">
          <Item
            id={item.id}
            imagenes={item.imagenes}
            titulo={item.titulo}
            precio={item.precio}
            stock={item.stock}
          />
        </div>
      ))}
    </>
  );
};
